
import { ASSET_MAINTENANCE_METADATA } from './asset-maintenance.metadata';
import { AssetMaintenanceBase } from './asset-maintenance.model.base';
import { CrudEntity, CrudEntityConstructionOptions } from '@scisys-uim/uim-common';


export interface AssetMaintenance extends AssetMaintenanceBase {
}

export interface AssetMaintenanceTransient { }

export class AssetMaintenance extends CrudEntity<AssetMaintenance, number, AssetMaintenanceTransient> implements AssetMaintenanceTransient {
  constructor(source?: Partial<AssetMaintenance>, options?: CrudEntityConstructionOptions<AssetMaintenance, number, AssetMaintenanceTransient>) {
    super(ASSET_MAINTENANCE_METADATA, source, options);
  }
  
  initialiseEntityDefaults() {
    super.initialiseEntityDefaults();
  }
  
  registerPropertyCalculators() {
    super.registerPropertyCalculators();
  }
}





